/*
 * @Author: c.k
 * @Date: 2023-03-03 13:52:11
 * @LastEditors: c.k
 * @LastEditTime: 2023-03-06 17:00:53
 * @Descripttion:
 */
import Vue from 'vue'
import mention from 'quill-mention'
import VueQuillEditor from 'vue-quill-editor'
import { quillEditor, Quill } from 'vue-quill-editor'
Vue.use(VueQuillEditor)
Vue.use(quillEditor)
Quill.register({
    'modules/mention': mention
})
